/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import Typography from '@material-ui/core/Typography';
import React from 'react';

const FourOhThree = () => (
  <Typography variant='h4' gutterBottom>
    403 - not authorized
  </Typography>
);

export default FourOhThree;
